import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HelpCircle, Shield, MessageCircle } from 'lucide-react';

export default function Footer() {
  const { t } = useTranslation('footer');

  return (
    <footer className="mt-auto py-8 bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-2">
            <img src="/logo.svg" alt="Bitfortex" className="w-6 h-6" />
            <span className="text-gray-600">© {new Date().getFullYear()} Bitfortex</span>
          </div>
          
          <nav className="flex items-center space-x-6">
            <Link
              to="/privacy"
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
            >
              <Shield className="w-4 h-4 mr-2" />
              <span>{t('privacy')}</span>
            </Link>
            <Link
              to="/support"
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              <span>{t('support')}</span>
            </Link>
            <Link
              to="/faq"
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
            >
              <HelpCircle className="w-4 h-4 mr-2" />
              <span>{t('faq')}</span>
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}